import React from "react";
import { Modal, ModalBody } from "reactstrap";
import { withTranslation } from "react-i18next";
import styles from "./AddStaff.module.scss";
import crossIcon from "../../../assets/images/cross.svg";
import updateIcon from "../../../assets/images/Update.svg";
import {
  bulkUpdatehelpItems,
  bulkUpdateSingleOfficehelpItems,
  bulkUpdateStaffForMultipleOfficeshelpItems,
} from "../../../constants";

const AddStaffHelpGuideModal = ({
  isOpen,
  onClose,
  t,
  globalStaffPage = false,
  isUpdateStaffForMultipleOffices,
}) => {
  const helpItems = isUpdateStaffForMultipleOffices
    ? bulkUpdateStaffForMultipleOfficeshelpItems
    : globalStaffPage
    ? bulkUpdatehelpItems
    : bulkUpdateSingleOfficehelpItems;
  return (
    <Modal
      isOpen={isOpen}
      toggle={() => onClose(false)}
      className="modal-md modal-dialog-centered modal-lg"
      modalClassName="custom-modal"
    >
      <span className="close-btn" onClick={() => onClose(false)}>
        <img src={crossIcon} alt="close" />
      </span>
      <ModalBody>
        <p className="title">{t("helpGuide")}</p>
        <div className={styles.modal_container}>
          <div className={styles.help_guide_header}>
            <img src={updateIcon} alt="help guide" />
            <h5 className={styles.title_style}>
              {isUpdateStaffForMultipleOffices
                ? t("staff.updateAcrossOffices")
                : globalStaffPage
                ? t("staff.bulkUpdateSelected")
                : t("staff.bulkUpdateSelectedSingleOffice")}
            </h5>
          </div>
          {isUpdateStaffForMultipleOffices ? <p>{(
            t("staff.updateStaffForMultipleOfficesHelpDescription")
          )}</p> : globalStaffPage ? (
            <p>{t("staff.bulkGlobalStaffHelpDescription")}</p>
          ) : (
            <p>{t("staff.bulkOfficeStaffHelpDescription")}</p>
          )}
          {helpItems.map((section, index) => (
            <div key={index} className="mb-3">
              <h5 className={styles.title_style}>{section.heading}</h5>
              <ul>
                {section.points.map((point, idx) => (
                  <li key={idx}>{point}</li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </ModalBody>
    </Modal>
  );
};
export default withTranslation()(AddStaffHelpGuideModal);
